/**
 * useWalletTransactions — F-009.3.
 *
 * TanStack Query hook per lo storico transazioni. I filtri (page/limit/reason)
 * fanno parte della query key → cambiarli rifetcha automaticamente.
 */
import { useQuery } from '@tanstack/react-query';
import type { WalletTransactionsResponse } from '@app/shared';

import {
  getWalletTransactions,
  type WalletTransactionsQueryInput,
} from '../lib/wallet-client';
import { walletQueryKeys } from '../lib/query-client';

export function useWalletTransactions(filters: WalletTransactionsQueryInput = {}) {
  return useQuery<WalletTransactionsResponse>({
    queryKey: walletQueryKeys.transactions(filters),
    queryFn: () => getWalletTransactions(filters),
  });
}
